import styled, { css } from 'styled-components';

const defaultColor = css`
  color: #ffffff;
  border: 2px solid transparent;
  background-repeat: no-repeat;
  background-size: calc(4px + 100%) calc(4px + 100%);
  background-position-x: -2px;
  background-position-y: -2px;
  background-image: linear-gradient(to right, #ff9259 0%, #ff2426 100%);
`;

const invertedColor = css`
  color: #ff441f;
  border: 2px solid #ff441f;
  background-image: none;
  background-color: #fff;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  width: 100%;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  cursor: pointer;

  &:focus {
    outline:none;
  }

  ${({ isInverted }) => (`
    ${!isInverted ? defaultColor : invertedColor}

    &:hover {
      ${!isInverted ? invertedColor : defaultColor}
    }
  `)}
`;
